import GuestCheckoutPage from './views/guestCheckout.page';

export default {
  views: { GuestCheckoutPage },
};
